
<kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-i-form-element"></span> {{title}}
  </div>
</kendo-dialog-titlebar>

<form [formGroup]="editForm"  class="k-form-inline">
  <div class="k-form-field" [hidden]="mode != FormModes.EDIT">
    <label class="form-label col-3 k-label" for="email">User</label>
    <div class="col-8">
      <label>{{organisationUser && 'user' in organisationUser ? organisationUser.user : ''}}</label>
    </div>
  </div>
  <div class="k-form-field" >
    <label class="form-label col-3 k-label" for="email">User Email</label>
    <div class="col-8">
      <input type="text" id="email" formControlName="email" class="form-control" appAutoFocus [hidden]="mode == FormModes.EDIT" style="text-transform: lowercase;">
      <label [hidden]="mode != FormModes.EDIT">{{organisationUser?.email}}</label>
      <div *ngIf="email?.invalid" class="alert alert-danger">
        <div *ngIf="email?.errors?.['required']">Email is required.</div>
        <div *ngIf="email?.errors?.['email']">Please enter a valid email address.</div>
      </div>
    </div>
  </div>

  <div class="k-form-field">
    <label  class="form-label col-3">User Roles</label>
    <div class="col-8">
      <div class="component-container">
        <kendo-formfield showHints="always">
<!--          <kendo-multiselect [data]="roles" textField="name" valueField="id" [(ngModel)]="selectedRoleIds"-->
<!--                             formControlName="userRoles"></kendo-multiselect>-->
          <kendo-multiselect [data]="roles" textField="name" valueField="id"
                             formControlName="user_roles"></kendo-multiselect>
          <div *ngIf="user_roles?.invalid" class="alert alert-danger">
            <div *ngIf="user_roles?.errors?.['required']">At least one User Role is required.</div>
          </div>
        </kendo-formfield>
      </div>
    </div>
  </div>

</form>

<kendo-dialog-actions>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="editForm.invalid">Save</button>
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
</kendo-dialog-actions>

